var __jsx = React.createElement;
import React from "react";
import { useModal } from "./ModalManager";
var Screen = function Screen(_ref) {
  var screenIndex = _ref.screenIndex,
    children = _ref.children;
  var _useModal = useModal(),
    currentScreen = _useModal.currentScreen;
  if (currentScreen !== screenIndex) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
export default Screen;